import React, { useState } from "react";
import logo from "../assets/logo.png";
import "./Header.css";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggle = () => {
    console.log("Menu opening...");
    setIsMenuOpen(true);
  };

  const handleClose = () => {
    console.log("Menu closing...");
    setIsMenuOpen(false);
  };
  const [openServices, setOpenServices] = useState(false);

  const toggleServices = (e) => {
    e.preventDefault(); // prevent page reload
    setOpenServices(!openServices);
  };
  return (
    <section className="header-menu-area">
      <div className="header-menu-fluid">
        <div className="container">
          <div className="row align-items-center menu-content">
            {/* Logo */}
            <div className="col-lg-3 col-6">
              <div className="logo-box">
                <a href="/" className="logo" title="Dotemb">
                  <img src={logo} alt="Dotemb" className="site-logo"  />
                </a>
              </div>
            </div>

            {/* Menu & Toggle */}
            <div className="col-lg-9 col-6 d-flex justify-content-end align-items-center">
              {/* Desktop Menu */}
              <nav className="main-menu d-none d-lg-block">
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/pricing">Pricing</a>
                  </li>
                  <li>
                    <a href="#">Services</a>
                    <ul className="dropdown-menu-item">
                      <li>
                        <a href="/embroidery">Embroidery Digitizing</a>
                      </li>
                      <li>
                        <a href="/vector">Vector Art Conversion</a>
                      </li>
                      <li>
                        <a href="/puff">3D / PUFF Digitizing</a>
                      </li>
                      <li>
                        <a href="/applique">Applique Digitizing</a>
                      </li>
                      <li>
                        <a href="/jacket">Jacket Back Digitizing</a>
                      </li>
                      <li>
                        <a href="/logo">Logo Digitizing</a>
                      </li>
                      <li>
                        <a href="/cap">Cap Digitizing Service</a>
                      </li>
                      <li>
                        <a href="/embroiderypatch">Embroidery Patches</a>
                      </li>
                      <li>
                        <a href="/sleev">Sleeve Digitizing</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="/faq">FAQ</a>
                  </li>
                  <li>
                    <a href="/portfolio">Portfolio</a>
                  </li>
                  <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                </ul>
              </nav>

              {/* Toggle Button (Mobile) */}
              <div
                className="side-menu-open d-lg-none"
                onClick={handleToggle}
                role="button"
                tabIndex={0}
              >
                <span className="menu__bar"></span>
                <span className="menu__bar"></span>
                <span className="menu__bar"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`side-nav-container ${isMenuOpen ? "active" : ""}`}>
        <div
          className="humburger-menu"
          onClick={handleClose}
          role="button"
          tabIndex={0}
        >
          <div className="humburger-menu-lines"></div>
          <div className="humburger-menu-lines"></div>
        </div>

        <div className="side-menu-wrap">
          <ul className="side-menu-ul">
            <li>
              <a href="/" onClick={handleClose}>
                Home <FaChevronRight className="menu-arrow" />
              </a>
            </li>
            <li>
              <a href="/pricing" onClick={handleClose}>
                Pricing <FaChevronRight className="menu-arrow" />
              </a>
            </li>

            {/* Services */}
            <li className="has-dropdown">
              <div
                className="menu-parent"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
                onClick={toggleServices} // clicking anywhere in this area toggles dropdown
              >
                {/* Clicking text also toggles now */}
                <span style={{ padding: "12px 16px", flex: 1, color: "#333" }}>
                  Services
                </span>

                {/* Arrow */}
                <div style={{ marginRight: "15px", marginTop: "10px" }}>
                  {openServices ? (
                    <FaChevronDown
                      style={{ color: "#999999", fontSize: "14px" }}
                    />
                  ) : (
                    <FaChevronRight
                      style={{ color: "#999999", fontSize: "14px" }}
                    />
                  )}
                </div>
              </div>

              {openServices && (
                <ul className="dropdown-menu-item">
                  <li>
                    <a href="/embroidery" onClick={handleClose}>
                      Embroidery Digitizing
                    </a>
                  </li>
                  <li>
                    <a href="/vector" onClick={handleClose}>
                      Vector Art Conversion
                    </a>
                  </li>
                  <li>
                    <a href="/puff" onClick={handleClose}>
                      3D / PUFF Digitizing
                    </a>
                  </li>
                  <li>
                    <a href="/applique" onClick={handleClose}>
                      Applique Digitizing
                    </a>
                  </li>
                  <li>
                    <a href="/jacket" onClick={handleClose}>
                      Jacket Back Digitizing
                    </a>
                  </li>
                  <li>
                    <a href="/logo" onClick={handleClose}>
                      Logo Digitizing
                    </a>
                  </li>
                  <li>
                    <a href="/cap" onClick={handleClose}>
                      Cap Digitizing Service
                    </a>
                  </li>
                  <li>
                    <a href="/embroiderypatch" onClick={handleClose}>
                      Embroidery Patches
                    </a>
                  </li>
                  <li>
                    <a href="/sleev" onClick={handleClose}>
                      Sleeve Digitizing
                    </a>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <a href="/faq" onClick={handleClose}>
                FAQ <FaChevronRight className="menu-arrow" />
              </a>
            </li>
            <li>
              <a href="/portfolio" onClick={handleClose}>
                Portfolio <FaChevronRight className="menu-arrow" />
              </a>
            </li>
            <li>
              <a href="/contact" onClick={handleClose}>
                Contact Us <FaChevronRight className="menu-arrow" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Header;
